import React from "react";
import "./elyon.scss";
import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Promoc from "../../../component/promo/promoc.jsx";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import Cardprodukdetail from "../../../component/cardprodukdetail/cardprodukdetail.jsx";
import prmo from "../../../component/promo/promocard.json";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import hsimages from "../../../asset/hardsell/hsimages.js";
import data from "../../data.json";
import Heroimages from "../../../asset/hero/heroimages.js";
import faselyon from "../../../asset/fascarousel/fas-elyon/fas-elyon.js";
import imgElyon8 from "../../../asset/imgrumah/img-elyon/img-elyon8/img-elyon8.js";
import imgElyon9 from "../../../asset/imgrumah/img-elyon/img-elyon9/img-elyon9.js";
const imgMap = {
  faselyon,
};
const imageMap = {
  imgElyon8,
  imgElyon9,
};

const elyon = () => {
  return (
    <div className="elyon">
      <div className="hero">
        {data.elyonab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.elyonab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Elyonp.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasElyon.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div className="produkcontainer">
        {dataproduk.Elyonp.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default elyon;
